export default __webpack_public_path__ + "static/media/circle-cross-3.10628b56.svg";